<div id="int-presence-edit-main" class="w-full h-full">
  <app-internal-toolbar
    [title]="
      ('internal.presence.editTitle' | translate) + (presence()?.startdate | date: 'shortDate')
    "
  >
    @if (api.hasPermission('delete_presence') && presence()?._id) {
      <reactive-button
        actions
        [label]="'general.delete' | translate"
        icon="delete"
        variant="outlined"
        severity="danger"
        (onClick)="deletePresence()"
      ></reactive-button>
    }

    <reactive-button
      actions
      [label]="'general.cancel' | translate"
      icon="close"
      variant="outlined"
      severity="secondary"
      (onClick)="cancelPresence()"
    ></reactive-button>

    <reactive-button
      actions
      [label]="'general.save' | translate"
      icon="add"
      variant="outlined"
      (onClick)="savePresence()"
    ></reactive-button>
  </app-internal-toolbar>

  <div class="p-4">
    <form [formGroup]="presenceForm" class="flex flex-col gap-4 mt-2 mb-4 w-fit">
      <div class="desktop flex flex-col">
        <label class="mb-2">{{ 'internal.presence.startdate' | translate }}</label>
        <p-datepicker
          formControlName="startdate"
          [invalid]="
            presenceForm.controls.startdate.invalid && presenceForm.controls.startdate.touched
          "
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
      </div>

      <p-floatlabel variant="on" class="mobile">
        <p-datepicker
          formControlName="startdate"
          [invalid]="
            presenceForm.controls.startdate.invalid && presenceForm.controls.startdate.touched
          "
          showIcon
          iconDisplay="input"
          [showTime]="true"
          [touchUI]="true"
          [showButtonBar]="true"
          hourFormat="24"
        />
        <label>{{ 'internal.presence.startdate' | translate }}</label>
      </p-floatlabel>

      <div class="flex flex-row items-center gap-2">
        <p-toggleswitch
          [ngModel]="showHiddenUsers()"
          (ngModelChange)="showHiddenUsers.set($event)"
          [ngModelOptions]="{ standalone: true }"
        />
        <span>{{ 'general.showHiddenUsers' | translate }}</span>
      </div>
    </form>

    <div id="int-presence-legend-grid" class="mt-8">
      <!-- Removed 1, 2 for no covid -->
      @for (pres of [0, 3, 4, 5, -1]; track pres; let i = $index) {
        <div class="int-presence-col">
          <div class="int-presence-cell" [style.background]="getPresenceColor(pres)">
            <mat-icon iconClass="noselect">{{ getPresenceIcon(pres) }}</mat-icon>
          </div>
          <div class="int-presence-cell">
            <div class="noselect" style="font-size: 16px">
              {{ 'internal.presence.tooltips.' + pres | translate }}
            </div>
          </div>
          <div></div>
        </div>
      }
    </div>

    <div id="int-presence-grid">
      <div class="int-presence-cell text-vertically" [style.grid-area]="'1 / 1'">
        <div class="noselect">
          {{ 'internal.presence.id' | translate }}
        </div>
      </div>

      <div
        class="int-presence-cell text-vertically"
        style="line-height: 150px"
        [style.grid-area]="'1 / 2'"
      >
        <div class="noselect">
          {{ 'internal.presence.name' | translate }}
        </div>
      </div>

      <div class="int-presence-cell text-vertically" [style.grid-area]="'1 / 3'">
        <div class="noselect">
          {{ 'internal.presence.presence' | translate }}
        </div>
      </div>

      @for (username of filteredUsers(); track username; let i = $index) {
        <div class="int-presence-cell noselect" [style.grid-area]="i + 2 + ' / 1'">
          {{ i + 1 }}
        </div>
        <div class="int-presence-cell" [style.grid-area]="i + 2 + ' / 2'">
          <div
            class="noselect"
            style="
              font-size: 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
            "
          >
            @if (getUserName(username) == username) {
              <mat-icon iconClass="noselect">delete</mat-icon>
            }
            @if (getUserHidden(username)) {
              <mat-icon iconClass="noselect">visibility_off</mat-icon>
            }
            {{ getUserName(username) }}
          </div>
        </div>
        <div
          class="int-presence-cell touch"
          [style.grid-area]="i + 2 + ' / 3'"
          (click)="changePresence(username)"
          [style.background]="getUserColor(username)"
        >
          <mat-icon iconClass="noselect">{{ getUserIcon(username) }}</mat-icon>
        </div>
      }
    </div>
  </div>
</div>
